export type CarLocation = "assigned" | "pool_opole" | "pool_wroclaw" | "sold";
export type CarFuelType = "petrol" | "diesel" | "lpg" | "electric" | "hybrid" | "other";
export type CarCategory = "passenger" | "truck" | "motorcycle";
export type CarOwnershipType = "owned" | "leased";
export type CarEuroCategory = "euro1" | "euro2" | "euro3" | "euro4" | "euro5" | "euro6" | "euro6d";

export const FUEL_TYPE_LABELS: Record<CarFuelType, string> = {
  petrol: "Benzyna", diesel: "Diesel", lpg: "LPG",
  electric: "Elektryczny", hybrid: "Hybryda", other: "Inne",
};
export const CAR_CATEGORY_LABELS: Record<CarCategory, string> = {
  passenger: "Osobowy", truck: "Ciężarowy", motorcycle: "Motocykl",
};
export const OWNERSHIP_TYPE_LABELS: Record<CarOwnershipType, string> = {
  owned: "Własność", leased: "Leasing",
};
export const EURO_CATEGORY_LABELS: Record<CarEuroCategory, string> = {
  euro1: "EURO 1", euro2: "EURO 2", euro3: "EURO 3",
  euro4: "EURO 4", euro5: "EURO 5", euro6: "EURO 6", euro6d: "EURO 6d",
};

export interface Car {
  id: string;
  brand: string;
  model: string;
  license_plate: string;
  year: number | null;
  color: string;
  vin: string;
  notes: string;
  is_active: boolean;
  current_location: CarLocation;
  current_location_display: string;
  current_holder: string | null;
  current_holder_name: string | null;
  display_name: string;
  inspection_due: string | null;
  insurance_due: string | null;
  first_registration_date: string | null;
  euro_category: CarEuroCategory | "";
  fuel_type: CarFuelType | "";
  car_category: CarCategory | "";
  ownership_type: CarOwnershipType | "";
  company: string | null;
  company_name: string | null;
  created_at: string;
  updated_at: string;
}

export type CarIssueStatus = "open" | "in_progress" | "resolved" | "rejected";
export type CarIssuePriority = "low" | "normal" | "high" | "critical";

export interface CarIssueReport {
  id: string;
  car: string;
  car_display: string;
  title: string;
  description: string;
  status: CarIssueStatus;
  status_display: string;
  priority: CarIssuePriority;
  priority_display: string;
  reporter: string | null;
  reporter_name: string | null;
  resolved_at: string | null;
  comment_count: number;
  created_at: string;
  updated_at: string;
}

export interface CarIssueComment {
  id: string;
  report: string;
  author: string | null;
  author_name: string | null;
  text: string;
  mentioned_users: string[];
  mentioned_user_names: string[];
  created_at: string;
  updated_at: string;
}

export interface FleetTodoCount {
  open_issues: number;
  expiring_soon: number;
  total: number;
}

export const ISSUE_STATUS_LABELS: Record<CarIssueStatus, string> = {
  open: "Otwarte",
  in_progress: "W trakcie",
  resolved: "Rozwiązane",
  rejected: "Odrzucone",
};

export const ISSUE_PRIORITY_LABELS: Record<CarIssuePriority, string> = {
  low: "Niski",
  normal: "Normalny",
  high: "Wysoki",
  critical: "Krytyczny",
};

export interface CarAssignment {
  id: string;
  car: string;
  location: CarLocation;
  location_display: string;
  holder: string | null;
  holder_name: string | null;
  date_from: string;
  date_to: string | null;
  notes: string;
  created_by: string | null;
  created_by_name: string | null;
  created_at: string;
}

export interface CarReservation {
  id: string;
  car: string;
  car_display: string;
  reserved_by: string;
  reserved_by_name: string;
  date_from: string;
  date_to: string;
  notes: string;
  created_at: string;
}

export const LOCATION_LABELS: Record<CarLocation, string> = {
  assigned: "Przydzielony",
  pool_opole: "Parking Opole",
  pool_wroclaw: "Parking Wrocław",
  sold: "Sprzedane",
};

export const LOCATION_COLORS: Record<CarLocation, "blue" | "gray" | "green" | "red"> = {
  assigned: "blue",
  pool_opole: "gray",
  pool_wroclaw: "green",
  sold: "red",
};
